let globalTrigger: (() => void) | null = null;

export function triggerConfetti() {
  if (Math.random() < 0.2) {
    globalTrigger?.();
  }
}

export function forceConfetti() {
  globalTrigger?.();
}

export function registerConfettiTrigger(trigger: () => void) {
  globalTrigger = trigger;
}

export function unregisterConfettiTrigger() {
  globalTrigger = null;
}
